export default {
    parts: ['container', 'value'],
    baseStyle: {
        container: {
            width: '100%',
            maxWidth: '342px',
            flexDirection: 'column',
            gap: {base: 4}
        },
        textProgress: {
            textStyle: 'bodySmRegular',
            textAlign: 'center'
        },
        value: {
            textStyle: 'bodySmBold'
        },
        progress: {
            height: "2px",
            width: "100%",
            backgroundColor: "webBasic.400"
        },
        progressBar: {
            height: "100%",
            backgroundColor: "webTheme.strokeDefault"
        }
    }
}
